import BorrowingPowerScreen from 'features/borrowingPower/BorrowingPowerScreen/BorrowingPowerScreen';
import React from 'react';

const BorrowingPowerPage = () => {
  return <BorrowingPowerScreen />;
};

export default BorrowingPowerPage;
